export enum AreaIds {
  CanalDirecto = 1,
  CanalBrokers = 2,
  Remo = 3,
  TramitesBuyers = 4,
  Propertymanagement = 5,
  Proveedores = 6,
}

export const AreaOptions = [
  { id: AreaIds.CanalDirecto, name: 'Canal Directo' },
  { id: AreaIds.CanalBrokers, name: 'Canal Brokers' },
  { id: AreaIds.Remo, name: 'Remo' },
  { id: AreaIds.TramitesBuyers, name: 'Tramites Buyers' },
  { id: AreaIds.Propertymanagement, name: 'Property management' },
  { id: AreaIds.Proveedores, name: 'Proveedores' },
];
